export enum ActionEnum {
    EDIT = 'edit',
    VIEW = 'view',
    DELETE = 'delete',
    VIEW_HISTORY = 'view_history',
    ACCESSES = 'edit_role_accesses',
    TRANSLATE = 'edit_entity_translations',
}

export enum TranslationDomainEnum {
    MESSAGES = 'messages',
    LEXIK_TRANSLATION_BUNDLE = 'LexikTranslationBundle',
    SECURITY = 'security',
    VALIDATORS = 'validators',
    USER_ADMINISTRATION = 'user_administration',
    COMPANY_ADMINISTRATION = 'company_administration'
}

export enum ResponseTypeEnum {
    SUCCESS = 'success',
    INFO = 'info',
    WARNING = 'warning',
    ERROR = 'error',
}

export const RegExEnum = {
    DUTCH_POSTAL_CODE_REGEX : /^[1-9][0-9]{3}\s?[A-Za-z]{2}$/,
    POSTAL_CODE_REGEX : /^[0-9a-zA-Z](?:[0-9a-zA-Z ]{0,13}[0-9a-zA-Z])?$/,
    HOUSE_NR_REGEX : /^[1-9]{1}[0-9]*$/i,
    NUMBERS_ONLY : /^[0-9]*$/,
}

export const CountryCodeEnum = {
    NETHERLANDS: 'NL'
}